dropSymbolAnimator = {};
dropSymbolAnimator.LUT = [
  [0, 0, 0],
  [-1, 0, 0],
  [-1, -1, 0],
  [-2, -2, 0],
  [-1, -1, -1],
  [-2, -2, -1],
  [-2, -2, -2],
  [-3, -3, -3],
];

dropSymbolAnimator.start = function (dropData, callback) {
  dropSymbolAnimator.dropData = dropData;
  dropSymbolAnimator.callback = callback;

  // Restore reels to original state (visible)
  var reel;
  var row;
  for (reel = 0; reel < 5; reel++) {
    for (row = 0; row < 3; row++) {
      if (dropData.tumbleData[reel][row] !== 0) {
        gameData.reels[reel].showSymbol(row, true);
      }
    }
  }

  // Now delete symbols that are being popped, and push in new symbols at the top
  for (reel = 0; reel < 5; reel++) {
    for (row = 0; row < 3; row++) {
      if (dropData.tumbleData[reel][row] !== 0) {
        gameData.reels[reel].removeSymbol(row);
      }
    }
  }

  // First, look up the movement we need for each symbol
  dropSymbolAnimator.symbolMovement = [];
  for (reel = 0; reel < 5; reel++) {
    var data = dropData.tumbleData[reel];
    var bitmask = 0;
    for (var i = 0; i < data.length; i++) {
      bitmask += data[i] !== 0 ? 1 << i : 0;
    }
    dropSymbolAnimator.symbolMovement.push(dropSymbolAnimator.LUT[bitmask]);
  }
};

dropSymbolAnimator.update = function (progress) {};

dropSymbolAnimator.complete = function () {};
